import { render, staticRenderFns } from "./foodModelAdmin.vue?vue&type=template&id=29c1d70e&scoped=true&"
import script from "./foodModelAdmin.vue?vue&type=script&lang=js&"
export * from "./foodModelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./foodModelAdmin.vue?vue&type=style&index=0&id=29c1d70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1d70e",
  null
  
)

export default component.exports